import { render } from "./TraspasoCreate.vue?vue&type=template&id=bf400b12&scoped=true"
import script from "./TraspasoCreate.vue?vue&type=script&lang=js"
export * from "./TraspasoCreate.vue?vue&type=script&lang=js"

import "./TraspasoCreate.vue?vue&type=style&index=0&id=bf400b12&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\frontend_zapi\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf400b12"]])

export default __exports__